import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-question-file",
  "use": "foquz-icon-question-file-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" id=\"foquz-icon-question-file\"><path d=\"M19 13v3.333c0 .708-.234 1.386-.65 1.886-.418.5-.983.781-1.572.781H3.222c-.59 0-1.154-.281-1.571-.781-.417-.5-.651-1.178-.651-1.886V13m14-7l-5-5-5 5m5-4v11\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol